const PING_INTERVAL = 5000;
// On an interval the frontend will be in contact with the backend to let it know it's still active.
let pingInterval: NodeJS.Timeout | undefined;

/**
 * Start the ping interval.
 */
const startPingInterval = () => {
    pingInterval = setInterval(() => {
        /* eslint-disable-next-line no-restricted-globals */
        self.postMessage("ping");
    }, PING_INTERVAL);
};

/* eslint-disable-next-line no-restricted-globals */
self.onmessage = (event) => {
    switch (event.data) {
        case "start":
            if (typeof pingInterval === "undefined") {
                startPingInterval();
            }
            break;
        case "stop":
            if (typeof pingInterval !== "undefined") {
                clearInterval(pingInterval);
                pingInterval = undefined;
            }
            break;
        default:
            console.error("unkown message", event.data);
    }
};

export {};
